export function timeMask(value) {
  const hours = [
    /[0-2]/,
    value.charAt(0) === '2' ? /[0-3]/ : /[0-9]/,
  ]
  const minutes = [/[0-5]/, /[0-9]/]
  return value.length > 2
    ? [...hours, ':', ...minutes]
    : hours
}

export function dateTimeMask(value) {
  // День (01-31)
  let daySecondDigit = /[0-9]/
  if (value.charAt(0) === '3') {
    daySecondDigit = /[0-1]/
  } else if (value.charAt(0) === '0') {
    daySecondDigit = /[1-9]/
  }
  const day = [/[0-3]/, daySecondDigit]

  // Месяц (01-12)
  let monthSecondDigit = /[0-9]/
  if (value.charAt(3) === '1') {
    monthSecondDigit = /[0-2]/
  } else if (value.charAt(3) === '0') {
    monthSecondDigit = /[1-9]/
  }
  const month = [/[0-1]/, monthSecondDigit]

  // Год (1970-2099)
  let yearSecondDigit = /[0-9]/
  let yearThirdDigit = /[0-9]/

  if (value.charAt(6) === '1') {
    yearSecondDigit = /[9]/ // 19XX
  } else if (value.charAt(6) === '2') {
    yearSecondDigit = /[0]/ // 20XX
  }

  // Третья цифра года
  if (value.charAt(6) === '1' && value.charAt(7) === '9') {
    yearThirdDigit = /[7-9]/ // 1970-1999
  } else if (value.charAt(6) === '2' && value.charAt(7) === '0') {
    yearThirdDigit = /[0-9]/ // 2000-2099
  }

  const year = [/[1-2]/, yearSecondDigit, yearThirdDigit, /[0-9]/]

  // Часы (00-23)
  const hours = [
    /[0-2]/,
    value.charAt(11) === '2' ? /[0-3]/ : /[0-9]/,
  ]

  // Минуты (00-59)
  const minutes = [/[0-5]/, /[0-9]/]

  // Секунды (00-59)
  const seconds = [/[0-5]/, /[0-9]/]

  // Построение маски в зависимости от длины введенного значения
  // value включает разделители: "01-01-1900 01:01:01" = 19 символов
  if (value.length < 3) {
    return day
  }
  if (value.length < 6) {
    return [...day, '-', ...month]
  }
  if (value.length < 11) {
    return [...day, '-', ...month, '-', ...year]
  }
  if (value.length < 14) {
    return [...day, '-', ...month, '-', ...year, ' ', ...hours]
  }
  if (value.length < 17) {
    return [...day, '-', ...month, '-', ...year, ' ', ...hours, ':', ...minutes]
  }
  return [...day, '-', ...month, '-', ...year, ' ', ...hours, ':', ...minutes, ':', ...seconds]
}
